<template>
    <el-dialog :title="$t('users.password_dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" :inline="false"  label-width="100%"   ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="12">
                 <el-col :span="12">
                    <el-form-item :label="$t('users.password')" :required="true">
                        <el-input type="password"  v-model="password1"  autofocus></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('users.repeat_password')" :required="true">
                        <el-input type="password"  v-model="password2" ></el-input>
                    </el-form-item>
                 </el-col>
             </el-row>
             <el-row>
                 <el-col :span="24">
                     <el-alert v-if="!is_valid_password().valid" :title="is_valid_password().error" type="error"></el-alert>
                     <el-alert v-else :title="$t('users.good_password')" type="success"></el-alert>
                 </el-col>
             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "change-password-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      password1: "",
      password2: "",
      user_id: -1
    }
  },
  methods: {
     show_me: function( user_id ) {
        this.user_id         = user_id;
        this.showPopup       = true;
        this.password1       = "";
        this.password2       = "";
    },
    is_valid_password: function(){
        var ret = { valid: true, error: "" };
        if( this.password1 != this.password2  ){
            ret.valid = false;
            ret.error = this.$t('passwords_dont_match');
        }

        if( this.password1.length < 6 ) 
        {
            ret.valid = false;
            ret.error = this.$t('password_too_short');
        }
        if( this.scorePassword(this.password1) < 50 )
        {
            ret.valid = false;
            ret.error = this.$t('password_too_week');
        }
        return ret;
    },
    scorePassword: function(pass) {
        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    },
    save: function() {
        
        if( !this.is_valid_password().valid ) {
            this.$message.error( this.is_valid_password().error );
            return;
        }

        this.loading = true;
        this.$http
          .post('users/change_password',  { id_user: this.user_id, password1: this.password1, password2: this.password2 } )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.$message( this.$t("users.password_change_success") );
              this.showPopup = false;
            } else {
              this.$router.push("/");
            }
          });
    }
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>